import { format } from 'date-fns';
export function isOffersPromoCardsEmpty(props) {
    return !props.currentPagePath;
}
export const getOfferDate = (dateFrom, dateTo, labels) => `${dateFrom
    ? `${labels.offersPromo_validFrom_text} ${dateFrom && format(dateFrom, 'dd-MM-yyyy')} `
    : ''}
   ${dateTo ? `${labels.offersPromo_validTo_text} ${dateTo && format(dateTo, 'dd-MM-yyyy')}` : ''}`;
